module.exports = __webpack_public_path__ + "static/media/logo.95dc37e0.svg";